import Image from 'next/legacy/image'
import styled from 'styled-components'

import { breakpoints } from '@/styles'

import stockDog from './images/stock_dog.png'
import stockGuy from './images/stock_guy.png'
import stockWoman from './images/stock_woman.png'

const ImagesContainer = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  margin-top: 90px;

  @media (max-width: ${breakpoints.tabletLandscape}) {
    flex-direction: column;
  }
`

const DoubleImageContainer = styled.div`
  display: flex;
  width: 67%;

  @media (max-width: ${breakpoints.tabletLandscape}) {
    width: 100%;
  }
`

const SingleImageContainer = styled.div`
  width: 33%;

  @media (max-width: ${breakpoints.tabletLandscape}) {
    width: 100%;
  }
`

const DoubleImageWrapper = styled.div`
  position: relative;
  height: 320px;
  width: 50%;

  @media (max-width: ${breakpoints.phoneMax}) {
    height: 125px;
  }
`

const SingleImageWrapper = styled(DoubleImageWrapper)`
  width: 100%;

  @media (max-width: ${breakpoints.tabletLandscape}) {
    height: 440px;
  }

  @media (max-width: ${breakpoints.phoneMax}) {
    height: 250px;
  }
`

const ImagesBlock = () => (
  <ImagesContainer>
    <DoubleImageContainer>
      <DoubleImageWrapper>
        <Image
          src={stockWoman}
          alt=""
          layout="fill"
          objectFit="cover"
          placeholder="blur"
        />
      </DoubleImageWrapper>
      <DoubleImageWrapper>
        <Image
          src={stockDog}
          alt=""
          layout="fill"
          objectFit="cover"
          placeholder="blur"
        />
      </DoubleImageWrapper>
    </DoubleImageContainer>
    <SingleImageContainer>
      <SingleImageWrapper>
        <Image
          src={stockGuy}
          alt=""
          layout="fill"
          objectFit="cover"
          placeholder="blur"
        />
      </SingleImageWrapper>
    </SingleImageContainer>
  </ImagesContainer>
)

export default ImagesBlock
